import { makeAutoObservable } from 'mobx';
import { RootStore } from 'app/store/rootStore';

export class NotificationsStore {
  private _rootStore: RootStore;

  public errorMessage: string | null = null;
  public warningMessage: string | null = null;
  public successMessage: string | null = null;

  constructor({ rootStore }: { rootStore: RootStore }) {
    this._rootStore = rootStore;
    makeAutoObservable(this);
  }
}
